module.exports = __webpack_public_path__ + "static/media/parrilla-1.6423046c.jpg";